import biodegradableZipperBagConfigurator from './productConfigurators/biodegradableZipperBag';
import blankFlatBottomPouchConfigurator from './productConfigurators/blankFlatBottomPouch';
import blankGussetedBagConfigurator from './productConfigurators/blankGussetedBag';
import blankPaperTubeConfigurator from './productConfigurators/blankPaperTube';
import blankStandUpPouchConfigurator from './productConfigurators/blankStandUpPouch';
import blankTinCanConfigurator from './productConfigurators/blankTinCan';
import canEndConfigurator from './productConfigurators/canEnd';
import customPrintedBeverageLabelConfigurator from './productConfigurators/customPrintedBeverageLabel';
import customPrintedFlatBottomPouchConfigurator from './productConfigurators/customPrintedFlatBottomPouch';
import customPrintedFlatPouchConfigurator from './productConfigurators/customPrintedFlatPouch';
import customPrintedGussetedBagConfigurator from './productConfigurators/customPrintedGussetedBag';
import customPrintedPaperTubeConfigurator from './productConfigurators/customPrintedPaperTube';
import customPrintedStandUpPouchConfigurator from './productConfigurators/customPrintedStandUpPouch';
import customPrintedStickerConfigurator from './productConfigurators/customPrintedSticker';
import customPrintedTinCanConfigurator from './productConfigurators/customPrintedTinCan';
import paperTinTieBagConfigurator from './productConfigurators/paperTinTieBag';
import resealableBagTapeConfigurator from './productConfigurators/resealableBagTape';
import roundSealStickerConfigurator from './productConfigurators/roundSealSticker';
import shippingCartonConfigurator from './productConfigurators/shippingCarton';
import stockedStickerConfigurator from './productConfigurators/stockedSticker';
import blankFlatPouchConfigurator from '~/data/productConfigurators/blankFlatPouchConfigurator';
import customPrintedBagLabelConfigurator from '~/data/productConfigurators/customPrintedBagLabel';
import designLabFlatBottomBagConfigurator from '~/data/productConfigurators/designLabFlatBottomBag';
import designLabGussetBagConfigurator from '~/data/productConfigurators/designLabGussetBag';
import designLabStandUpPouchConfigurator from '~/data/productConfigurators/designLabStandUpPouch';
import designLabTinCanConfigurator from '~/data/productConfigurators/designLabTinCan';
import stockedFormingShoe from '~/data/productConfigurators/stockedFormingShoe';
import { ProductViewConfigurator } from '~/types/configurator';

const configurators: {
    [index: string]: ProductViewConfigurator;
} = {
    'blank-gusseted-bag': blankGussetedBagConfigurator,
    'blank-flat-bottom-pouch': blankFlatBottomPouchConfigurator,
    'blank-stand-up-pouch': blankStandUpPouchConfigurator,
    'paper-tin-tie-bag': paperTinTieBagConfigurator,
    'biodegradable-zipper-bag': biodegradableZipperBagConfigurator,
    'blank-tin-can': blankTinCanConfigurator,
    'can-end': canEndConfigurator,
    'blank-paper-tube': blankPaperTubeConfigurator,
    'shipping-carton': shippingCartonConfigurator,
    'round-seal-sticker': roundSealStickerConfigurator,
    'resealable-bag-tape': resealableBagTapeConfigurator,
    'custom-printed-gusseted-bag': customPrintedGussetedBagConfigurator,
    'custom-printed-flat-bottom-pouch':
        customPrintedFlatBottomPouchConfigurator,
    'custom-printed-stand-up-pouch': customPrintedStandUpPouchConfigurator,
    'custom-printed-flat-pouch': customPrintedFlatPouchConfigurator,
    'custom-printed-tin-can': customPrintedTinCanConfigurator,
    'custom-printed-bag-label': customPrintedBagLabelConfigurator,
    'custom-printed-paper-tube': customPrintedPaperTubeConfigurator,
    'custom-printed-sticker': customPrintedStickerConfigurator,
    'custom-printed-beverage-label': customPrintedBeverageLabelConfigurator,
    'design-lab-gusset-bag': designLabGussetBagConfigurator,
    'design-lab-flat-bottom-bag': designLabFlatBottomBagConfigurator,
    'design-lab-tin-can': designLabTinCanConfigurator,
    'design-lab-stand-up-pouch': designLabStandUpPouchConfigurator,
    'stocked-sticker': stockedStickerConfigurator,
    'blank-flat-pouch': blankFlatPouchConfigurator,
    'forming-shoe': stockedFormingShoe,
};

export default configurators;
